import styled from 'styled-components'
import { Wrapper, Flex } from '@raysync/common/components'
import { Media, multiLineTextEllipsis } from '@raysync/common/theme'
import Bg from './bg.png'

export const Banner = styled.div`
  background: url(${Bg}) no-repeat 100% 100%;
  height: 140px;
  padding: 30px 0;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  p {
    width: 100%;
    text-align: center;
    margin-top: 14px;
    color: #252a3a;
  }
  ${Media.phone`
    height: 1.8rem;
    padding: .4rem;
    margin-top: .3rem;
    p {
      margin-top: .18rem;
    }
  `}
`
export const ContentWrap = styled(Wrapper)`
  display: flex;
  padding: 40px 0 80px;
  ${Media.phone`
    flex-wrap: wrap;
    padding-top: .4rem 
    padding-bottom: .6rem;
  `}
`

export const FilterBar = styled.div`
  width: 200px;
  min-width: 200px;
  padding-top: 6px;
  h5 {
    font-weight: bold;
  }
  label {
    width: 100%;
    color: #636772;
    font-size: 14px;
    margin: 16px 0;
    display: flex;
    align-items: center;
    span {
      line-height: 1;
    }
    input {
      cursor: pointer;
    }
    > div {
      width: 16px;
      height: 16px;
      border-radius: 3px;
    }
  }
  ${Media.phone`
    flex-wrap: wrap;
    width: unset;
    h5 {
      font-size: .3rem;
    }
    > div {
      display: flex;
      flex-wrap: wrap;
      label {
        width: unset;
        margin: .28rem .24rem 0 0;
      }
    }
  `}
`
export const PostContainer = styled.div`
  width: 100%;
  ${Media.phone`
    margin-top: .6rem;
  `}
`
export const PostItem = styled.div`
  color: #252a3a;
  font-size: 14px;
  margin-bottom: 30px;
  h4 {
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
    span {
      font-weight: bold;
      color: ${p => p.theme.color.secondary};
    }
  }
  p {
    line-height: 1.5;
    margin: 8px 0 6px;
    ${multiLineTextEllipsis(3)};
    span {
      color: ${p => p.theme.color.secondary};
    }
  }
  > span {
    color: #636772;
    line-height: 1;
  }
  ${Media.phone`
    margin-bottom: .4rem;
    h4 {
      font-size: .28rem;
    }
    p {
      margin: .1rem 0 0;
      font-size: .2rem;
    }
   > span {
      font-size: .2rem;
    }
  `}
`
export const PaginationWrapper = styled(Flex)`
  margin: 10px 0 60px 0;
  justify-content: flex-end;
  ${Media.phone`
    margin: .1rem 0 0;
    justify-content: center;
  `}
`
